import React, { useState } from "react";
import SideBar from "./SideBar";
import TopBar from "./TopBar";
import "../styles/Layout.css";

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`layout ${isOpen ? "" : "sidebar-collapsed"}`}>
      <div className={`sidebar-block ${isOpen ? "" : "hidden"}`}>
        <SideBar isOpen={isOpen} toggleSidebar={toggleSidebar} />
      </div>
      <div className="main-content">
        <TopBar />

        <div className="content">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
